<template>
  <v-card
    class="w-50 py-8 px-6 text-center"
    elevation="0">
    <v-card-title> パスワード変更</v-card-title>

    <v-card-text class="mt-4">
      <!-- エラーメッセージ -->
      <v-alert
        v-if="props.error"
        type="error"
        variant="tonal"
        class="mb-8 text-left">
        {{ props.error }}
      </v-alert>

      <v-alert
        v-if="props.msg"
        type="info"
        variant="tonal"
        class="mb-8 text-left">
        {{ props.msg }}
      </v-alert>

      <v-form
        v-model="sendable"
        ref="loginForm"
        @submit.prevent="submit">
        <v-text-field
          v-model="email"
          label="メールアドレス"
          variant="outlined"
          :rules="[rules.required]"
          :disabled="props.loading"
          clearable
          block>
        </v-text-field>

        <v-text-field
          v-model="code"
          label="認証コード"
          variant="outlined"
          :rules="[rules.required]"
          :disabled="props.loading"
          clearable
          block></v-text-field>

        <v-text-field
          label="パスワード"
          v-model="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          variant="outlined"
          :rules="[rules.required]"
          :disabled="props.loading"
          @click:append="showPassword = !showPassword"
          clearable></v-text-field>

        <v-text-field
          label="パスワード（確認）"
          v-model="confirmPassword"
          :append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showConfirm ? 'text' : 'password'"
          variant="outlined"
          :rules="[rules.required, rules.confirm]"
          :disabled="props.loading"
          @click:append="showConfirm = !showConfirm"
          clearable></v-text-field>

        <!-- v-switch パスワード表示切替 -->

        <v-btn
          :disabled="!sendable"
          :loading="props.loading"
          type="submit"
          class="my-4"
          variant="flat"
          color="primary"
          size="large"
          block>
          パスワード変更
        </v-btn>

        <v-btn
          color="primary"
          variant="tonal"
          size="large"
          @click="cancel"
          block>
          キャンセル
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps({
  loading: Boolean,
  error: String,
  email: String,
  msg: String
});

const emit = defineEmits<{
  submit: [email: string, code: string, password: string];
  cancel: [];
}>();

const sendable = ref(false);

const email = ref(props.email);
const code = ref('');

const password = ref('');
const showPassword = ref(false);

const confirmPassword = ref('');
const showConfirm = ref(false);

const rules = {
  required: (value) => !!value || '必須項目です',
  confirm: () => password.value == confirmPassword.value || 'パスワードが一致しません'
};

async function submit() {
  emit('submit', email.value, code.value, password.value);
}

async function cancel() {
  emit('cancel');
}
</script>
